const insightDetailTypes = {
    PAGE: 'PAGE',
    DRAWER: 'DRAWER',
} as const;

export type InsightDetailType = (typeof insightDetailTypes)[keyof typeof insightDetailTypes];

export default insightDetailTypes;
